import styled from 'styled-components';

const Wrapper = styled.div`
    padding: 11px 25px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid #D7DBE1;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    background-color: #22292F;
    min-height: 73px;
    z-index: 99;

    ${props => props.typeAuth && `
        @media only screen and (max-width: 1024px) {
            position: relative;
            position: -webkit-relative;
            padding: 20px 20px 0px 20px;
            border-width: 0px;
        }
    `}
`;

export default Wrapper;